import { useQuery } from '@tanstack/react-query'
import { getBackgroundList } from '../../service/list'

function useGetBg() {
  return useQuery({
    queryKey: ['get-background-list'],
    queryFn: () => getBackgroundList(),
    staleTime: 6 * 1000,
  })
}

export default useGetBg
